import { useLocation, useParams } from 'react-router-dom';
import { AppRoute, routes } from '../config';

type Options = {
  matchPrefix?: boolean;
};

/**
 * A hook to check if you are currently in a given route
 *
 * It automatically accounts for route params
 *
 * @param route The route to check for
 */
export function useIsRoute(route: AppRoute, { matchPrefix = false }: Options = {}): boolean {
  const { pathname } = useLocation();
  const routeParams = useParams();

  const routeConfig = routes[route];

  if (!routeConfig) return false;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const wantedPath = (routeConfig as any).getPath?.(routeParams) ?? routeConfig.path;

  const ok = wantedPath === pathname;

  if (ok || !matchPrefix) return ok;

  return wantedPath !== '/' && pathname.startsWith(wantedPath);
}
